import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { getRiskLevel, getStatusColor } from '../../data/helpers';

const { FiMail, FiMapPin, FiUser, FiBriefcase, FiCalendar, FiClock } = FiIcons;

const InfoChip = ({ icon, label }) => (
  <div className="flex items-center gap-1.5 text-sm text-slate-500">
    <SafeIcon icon={icon} className="text-slate-400 flex-shrink-0" />
    <span>{label}</span>
  </div>
);

const ProfileHeader = ({ learner }) => {
  const risk = getRiskLevel(learner.phishingRiskScore || 0);
  const statusColor = getStatusColor(learner.compStatus || 'Not Started');

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
      <div className="h-20 bg-[#0f172a]" />
      <div className="px-6 pb-6">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 -mt-10 mb-5">
          <div className="w-20 h-20 rounded-2xl bg-white text-slate-700 flex items-center justify-center text-2xl font-bold border-4 border-slate-100 shadow-sm flex-shrink-0">
            {learner.firstName?.[0] || ''}{learner.lastName?.[0] || ''}
          </div>
          <div className="flex gap-2 flex-wrap">
            <span className={`px-3 py-1 rounded-full text-xs font-semibold border ${statusColor}`}>
              {learner.compStatus || 'Not Started'}
            </span>
            <span className={`px-3 py-1 rounded-full text-xs font-semibold border ${risk.color}`}>
              Risk: {learner.phishingRiskScore || 0}% · {risk.label}
            </span>
            <span className="px-3 py-1 rounded-full text-xs font-semibold border border-slate-200 bg-slate-50 text-slate-600">
              {learner.employmentStatus || 'Active'}
            </span>
          </div>
        </div>

        <h2 className="text-xl font-bold text-slate-800 mb-0.5">{learner.firstName} {learner.lastName}</h2>
        <p className="text-slate-500 text-sm mb-4">{learner.email}</p>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
          <InfoChip icon={FiBriefcase} label={learner.department || 'No Department'} />
          <InfoChip icon={FiUser} label={`Mgr: ${learner.manager || 'N/A'}`} />
          <InfoChip icon={FiMapPin} label={learner.location || 'Remote'} />
          <InfoChip icon={FiCalendar} label={learner.lastTrainingDate ? `Last trained ${learner.lastTrainingDate}` : 'Never trained'} />
        </div>
      </div>
    </div>
  );
};

export default ProfileHeader;